var _typeof = require("/builds/redtrack/publishers/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/typeof");

var NATIVE_SYMBOL = require('../internals/native-symbol');

module.exports = NATIVE_SYMBOL // eslint-disable-next-line no-undef
&& !Symbol.sham // eslint-disable-next-line no-undef
&& _typeof(Symbol.iterator) == 'symbol';